module.exports = __webpack_public_path__ + "static/media/Avinita Shetty.a2af4ce4.jpg";